import { t } from '@/i18n'

export const resourceLevelMap = {
  ResourceLevelJunior: { label: t('初级'), class: 'resource-level-junior' },
  ResourceLevelMiddle: { label: t('中级'), class: 'resource-level-middle' },
  ResourceLevelSenior: { label: t('高级'), class: 'resource-level-senior' },
}

// 风险等级映射
export const riskLevelMap = {
  RiskLevelLow: { label: t('低危'), class: 'leak-low' },
  RiskLevelMiddle: { label: t('中危'), class: 'leak-center' },
  RiskLevelHigh: { label: t('高危'), class: 'leak-high' },
  RiskLevelGross: { label: t('严重'), class: 'leak-severity' },
}

// 模板类型选项
export const templateTypeOptions = [
  { label: t('系统内置'), value: 'OriginTypeSystem' },
  { label: t('手动添加'), value: 'OriginTypeCustom' },
]

// 风险等级选项
export const riskLevelOptions = [
  { label: t('低危'), value: 'RiskLevelLow' },
  { label: t('中危'), value: 'RiskLevelMiddle' },
  { label: t('高危'), value: 'RiskLevelHigh' },
  { label: t('严重'), value: 'RiskLevelGross' },
]

// 用例分级选项
export const resourceLevelOptions = [
  { label: t('初级'), value: 'ResourceLevelJunior' },
  { label: t('中级'), value: 'ResourceLevelMiddle' },
  { label: t('高级'), value: 'ResourceLevelSenior' },
]

// 存活状态选项
export const aliveStatusOptions = [
  { label: t('存活'), value: 'AliveStatusTrue' },
  { label: t('不存活'), value: 'AliveStatusFalse' },
]

// 优先级选项
export const priorityOptions = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
]

// 协议选项
export const protocolOptions = [
  { value: 'http', label: 'http://' },
  { value: 'https', label: 'https://' },
  { value: 'socks5', label: 'socks5://' },
]

// 过滤条件选项
export const conditionOptions = [
  { value: 'condition_anyway', label: t('任意用例防护失效') },
  { value: 'condition_all_failed', label: t('全部用例防护失效') },
]

// 调度器类型选项
export const schedulerTypeOptions = [
  { value: 'scheduler_type_daily', label: t('每日') },
  { value: 'scheduler_type_weekly', label: t('每周') },
  { value: 'scheduler_type_monthly', label: t('每月') },
]

// 执行类型选项
export const executeTypeOptions = [
  { value: 1, label: t('即时任务') },
  { value: 2, label: t('定时任务') },
  { value: 3, label: t('周期任务') },
]

// 验证模式配置
export const verificationModeConfig = {
  mode2: {
    id: 2,
    label: 'Agent',
    targetLabel: t('外部情报'),
    description: t('Agent → 外部情报'),
  },
}

// 默认表单状态
export const defaultFormState = {
  verifyMode: [2],
  name: '',
  executeType: 1,
  executionTimes: undefined,
  priority: 3,
  executeTemplateLatestCase: true,
  speed: 10,
  schedulerType: 'scheduler_type_immediate',
  taskTime: null as any,
  hideRecipientFields: false,
  dayOfWeek: [] as number[],
  dayOfMonth: [] as number[],
  send: false,
  filter: false,
  condition: 'condition_anyway',
  timeout: 5,
  groupId: '',
  enableAuth: false,
  account: '',
  password: '',
  proxy: '',
  protocol: 'http',
  deviceIds: [] as any[],
  emailList: [] as string[],
  dnsSinkhole: '',
  agentId: '',
  hostId: '',
}

// 分页配置
export const paginationConfig = {
  defaultPageSize: 10,
  showSizeChanger: true,
  showTotal: (total: number) => `${t('共')} ${total} ${t('条')}`,
}

// 表格列宽配置
export const tableColumnWidths = {
  executeUpdate: 80,
  caseName: '20%',
  riskLevel: '15%',
  resourceLevel: '15%',
  attackType: '15%',
  updateTime: '15%',
  action: '10%',
}

// 表单验证规则
export const validationRules = {
  taskName: [
    { required: true, message: t('请输入任务名称') },
    { max: 50, message: t('任务名称最多50字') },
    { pattern: /^(?=.*\S).+$/, message: t('任务名称不能全部为空格!') },
  ],
  templateName: [
    { required: true, message: t('请输入模板名称') },
    { max: 99, message: t('模板名称最多99字') },
    { pattern: /^(?=.*\S).+$/, message: t('模板名称不能全部为空格') },
  ],
  verificationMode: [{ required: true, message: t('请选择验证模式') }],
  agentId: [{ required: true, message: t('请选Agent名称/IP') }],
  account: [{ required: true, message: t('请输入账号') }],
  password: [{ required: true, message: t('请输入密码') }],
  emailList: [{ required: true, message: t('请选择发送邮箱') }],
  condition: [{ required: true, message: t('请选择过滤条件') }],
  taskTime: [{ required: true, message: t('请选择执行开始时间') }],
  dayOfWeek: [{ required: true, message: t('请选择星期') }],
  dayOfMonth: [{ required: true, message: t('请选择日期') }],
  proxy: [{ required: true, message: t('启用账密认证时，代理池为必填项') }],
}
